import BaseComponent from './BaseComponent';

class RestrictedLink extends BaseComponent {
    constructor(el) {
        super(el);
        el.addEventListener('click', (e) => {
            if (el.dataset.lock == 1) {
                e.preventDefault();
                window.location.hash = 'restricted-link';
                document.getElementById('restricted-link-button').href = el.href;
            }
        });
    }
}

export default RestrictedLink;
